import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert} from 'reactstrap';

import Selectors from "~/state/selectors.ts";
import useEffectOnce from "~/hooks/use-effect-once.ts";
import {actions} from "~/state/reducers/codes-reducer.ts";

function withCodes<P>(WrappedComponent: React.ComponentType<P>) {
    const WithCodesComponent: FC<P> = (props) => {
        const dispatch = useDispatch();
        const metaCodes = useSelector(Selectors.getMetaCodes);

        useEffectOnce(() => {
            if (metaCodes?.fetchingCodes !== true) {
                dispatch(actions.loadCodes())
            }
        });

        return (
            <>
                {metaCodes?.loadedCodes ? <WrappedComponent {...props}/> :
                    <Alert className="m-4" color="info">Loading...</Alert>}
            </>
        );
    }

    return WithCodesComponent;
}

export default withCodes;
